import { useCallback } from 'react'

import { useRouter } from 'next/router'

import { ChevronLeftIcon } from '../icons'

// TODO: アプリ内に履歴を持って、賢い戻るボタンにしたい
// 課題: 通常のブラウザバックを Next.js のイベントでキャッチできなそうなので、ブラウザバックと組み合わせて破綻しない方法を考える必要がある

export const BackButton: React.FC<{ onClick?: () => void }> = (props) => {
  const router = useRouter()
  const back = useCallback(() => {
    props.onClick ? props.onClick() : router.back()
  }, [props, router])

  return (
    <button type="button" onClick={back} className="outline-none">
      <ChevronLeftIcon fill="#fff" />
    </button>
  )
}
